import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import AxiosInstance from 'utils/AxiosInstance'

function SuccessPayment() {
  const history = useHistory()

  const sessionId = window?.location?.search
    ?.split('?')
    ?.at(1)
    ?.split('=')
    ?.at(1)

  useEffect(() => {
    if (
      !window.location.search ||
      !window?.location?.search?.split('?')?.at(1)?.includes('session_id')
    ) {
      history.push('/public-catalog')
    }
  }, [history])

  useEffect(() => {
    if (sessionId) {
      AxiosInstance.post('/courses/payment-success', { sessionId })
        .then((data) => {
          console.log(data, 'leart27')
          history.push(`/course/${data.course_id}`)
        })
        .catch((err) => {
          console.error(err)
        })
    }
  }, [sessionId, history])

  return <></>
}

export default SuccessPayment
